module.exports = __webpack_public_path__ + "static/img/fullscreen-image_training_600.e12b2f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/training/fullscreen-image_training_600.png
// module id = 2nXZ
// module chunks = 0